import { put, select, takeLatest } from 'redux-saga/effects'
import { VitalsConstants } from '../store/vitals.constants'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'
import { IPatientVitals } from '../store/vitals.types'
import { setStrokeScaleScoreTotal } from '../store/vitals.actions'

export function* setRaceStrokeScaleScoreMap() {
  const patientVital: IPatientVitals = yield select(getPatientVitalsSelector)
  const { raceStrokeScaleScoreMap } = patientVital
  patientVital.raceStrokeScaleScoreMap = raceStrokeScaleScoreMap
  if (raceStrokeScaleScoreMap.size) {
    let totalStrokeScaleScore = 0
    raceStrokeScaleScoreMap.forEach((option) => {
      totalStrokeScaleScore = totalStrokeScaleScore + (option.id || 0)
    })
    yield put(setStrokeScaleScoreTotal(totalStrokeScaleScore))
  } else {
    yield put(setStrokeScaleScoreTotal(null))
  }
}

export function* setRaceStrokeScaleScoreMapSaga() {
  yield takeLatest([VitalsConstants.SET_RACE_STROKE_SCALE_SCORE_MAP], setRaceStrokeScaleScoreMap)
}
